/* @flow */

import React from 'react';

import { allRoles, userManagement } from 'permissions/general';

import UserProfile from 'views/UserProfile/UserProfile';
import SelectedUserProfile from 'views/SelectedUserProfile/SelectedUserProfile';
import SupportForm from 'forms/SupportForm/SupportForm';
import UsersReportView from 'tables/UsersReportView/UsersReportView';

import type { TypeComponent } from './types';

const userRoutes = [
  {
    path: '/users',
    title: 'general:document_titles.user_management.title',
    component: UsersReportView,
    exact: true,
    permissions: allRoles,
  },
  {
    path: '/profile',
    title: 'general:document_titles.user_management.profile',
    title_keys: ['activeUser.full_name'],
    component: UserProfile,
    exact: true,
    permissions: allRoles,
  },
  {
    path: '/users/profile/:selectedUserId',
    title: 'general:document_titles.user_management.profile',
    title_keys: ['selectedUser.full_name'],
    component: function SelectedUserProfilePage(props: *): TypeComponent {
      return <SelectedUserProfile mode="edit" selectedUserId={props.match.params.selectedUserId} />;
    },
    exact: true,
    permissions: userManagement,
  },
  {
    path: '/users/invite',
    title: 'general:document_titles.user_management.invite',
    component: function SelectedUserProfilePage(props: *): TypeComponent {
      return <SelectedUserProfile />;
    },
    exact: true,
    permissions: userManagement,
  },
  {
    path: '/support',
    title: 'general:document_titles.user_management.support',
    component: SupportForm,
    exact: true,
    permissions: allRoles,
  },
];

export default userRoutes.map(item => ({
  ...item,
  store: ['userStore'],
}));
